export default __webpack_public_path__ + "../ckeditor/plugins/clipboard/dialogs/paste.js";